import { __awaiter, __generator } from "tslib";
/**
 * Creates a "cache-network-race" persistence data flow that can be parameterized.
 * @param readNetwork - A callback that returns a Promise that returns the result from the network. Will be persisted once it arrives successfully.
 * @param readPersistence - A callback that returns a Promise that will read from persistence and return the stored data.
 * @param writeToPersistence - A callback that returns a Promise that accepts data arriving from the network, and will resolve once completed persisting the data.
 */
export function createCacheNetworkRaceOperation(readNetwork, readPersistence, writeToPersistence) {
    return __awaiter(this, void 0, void 0, function () {
        var networkRead, cacheRead, safeCachePromise, networkReadAndPersist;
        return __generator(this, function (_a) {
            networkRead = readNetwork();
            cacheRead = readPersistence();
            safeCachePromise = cacheRead.then(function (data) { return (data ? { result: data, fromPersistence: true } : null); }, function () { return null; });
            networkReadAndPersist = networkRead.then(function (networkData) {
                writeToPersistence(networkData);
                return { result: networkData, fromPersistence: false };
            });
            return [2 /*return*/, Promise.race([safeCachePromise, networkReadAndPersist]).then(function (result) { return result || networkReadAndPersist; }, function () {
                    return safeCachePromise.then(function (cacheResult) { return cacheResult || networkReadAndPersist; });
                })];
        });
    });
}
//# sourceMappingURL=createCacheNetworkRaceOperation.js.map